import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.50131 0C0.673266 0 0 0.672397 0 1.50184V19.4982C0 20.331 0.672158 21 1.50131 21H3.15762L4.35 24L7.50288 21H22.4987C23.3267 21 24 20.3276 24 19.4982V1.50184C24 0.669036 23.3278 0 22.4987 0H1.50131Z",
      fill: "#7F7466"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8.10001",
      cy: "6.6001",
      r: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "15.9",
      cy: "6.6001",
      rx: "1.5",
      ry: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.85001 15H16.05C16.4642 15 16.8 14.6642 16.8 14.25C16.8 13.8358 16.4642 13.5 16.05 13.5H8.85001C8.43579 13.5 8.10001 13.8358 8.10001 14.25C8.10001 14.6642 8.43579 15 8.85001 15Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }